import { render, staticRenderFns } from "./OrganizationPlan.vue?vue&type=template&id=c06622c4&scoped=true&"
import script from "./OrganizationPlan.vue?vue&type=script&lang=js&"
export * from "./OrganizationPlan.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPlan.vue?vue&type=style&index=0&id=c06622c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06622c4",
  null
  
)

export default component.exports